<template>
        <footer class="stdenis-footer">
        <div class="container">
            <div class="stdenis-copy">
                &copy; Copyright <strong>St.Denis Catholic Church.</strong>
                All Rights Reserved
            </div>
            <div class="stdenis-credits">
                Powered by <b><a href="https://www.parishbulletin.org" style="color:#E12993">ParishBulletin</a></b>
            </div>
        </div>

    </footer>
</template>

<script>
    export default {
        name: "DashFooter"
    }
</script>

<style scoped>
    .stdenis-footer{
        background: #3f83d4;
        padding: 0 0 30px 0;
        color: #ffffff;
        font-size: 14px;
    }
    .stdenis-footer .footer-top{
        background: #3578bc;
        padding: 60px 0 30px 0;
    }
    .stdenis-footer .footer-top h4:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        height: 2px;
        background: #E12993;
        width: 60px;
    }
    .stdenis-footer .footer-top .footer-info{
        margin-bottom: 30px;
    }
    .stdenis-footer .footer-top .footer-info h3{
        font-size: 34px;
        margin: 0 0 20px 0;
        padding: 2px 0 2px 10px;
        line-height: 1;
        font-weight: 700;
        letter-spacing: 3px;
        border-left: 4px solid #E12993;
        color: #ffffff;
        text-transform: uppercase;
    }
    .stdenis-footer .footer-top .footer-info p{
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 0;
        color: #ffffff;
    }
    .stdenis-footer .footer-top .footer-links{
        margin-bottom: 30px;
    }
    .stdenis-footer .footer-top .footer-links h4{
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        text-transform: uppercase;
        position: relative;
        padding-bottom: 12px;
    }
    .stdenis-footer .footer-top .footer-links ul{
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: left;
    }
    .stdenis-footer .footer-top .footer-links ul li{
        border-bottom: 1px solid rgba(255,255,255,0.5);
        padding: 10px 0;
    }
    .stdenis-footer .footer-top .footer-links ul li:first-child{
        padding-top: 0;
    }
    .stdenis-footer .footer-top .footer-links p{
        line-height: 26px;
    }
    .stdenis-footer .footer-top .footer-links p, .stdenis-footer .footer-top .footer-links b{
        color:#ffffff;
    }
    .stdenis-footer .footer-top .footer-links ul i{
        padding-right: 8px;
        color: #ffffff;
    }
    .stdenis-footer .footer-top .footer-links ul a{
        color: #ffffff;
        transition: all .3s linear;
    }
    .stdenis-footer .footer-top .footer-links ul a:hover{
        text-decoration: none;
        color: #E12993;
    }
    .stdenis-footer .stdenis-copy{
        text-align: center;
        padding-top: 30px;
        color: #ffffff;
    }
    .stdenis-footer .stdenis-copy strong{
        color: #ffffff;
    }
    .stdenis-footer .stdenis-credits{
        text-align: center;
        font-size: 13px;
        color: #ffffff;
    }
</style>